import { useCallback } from 'react';
import { css } from '@emotion/react';
import {
  LocationDetailsTray as LocationServiceDetails,
  LocationServiceLocationItem,
  useLocationService,
  usePinnedLocations,
} from '@frontend/wam-location-service';
import { theme } from '@frontend/theme';

export type LocationDetailsTrayProps = {
  onClose: () => void;
};
const styles = {
  trayWrapper: css({
    margin: `-${theme.spacing(4)}`,
    height: '105%',
  }),
};

export const LocationDetailsTray = ({ onClose }: LocationDetailsTrayProps) => {
  const { currentLocation, currentLocationChildren, setCurrentLocationId } = useLocationService();

  const { addLocation, removeLocation, isPinnedLocation } = usePinnedLocations();

  const onPinLocation = useCallback(
    (location: LocationServiceLocationItem, pinned: boolean) => {
      if (pinned) {
        addLocation(location);
      } else {
        removeLocation(location.locationId);
      }
    },
    [addLocation]
  );

  const onChangeLocation = useCallback(
    (location: LocationServiceLocationItem) => {
      setCurrentLocationId(location.locationId);
      addLocation(location);
    },
    [addLocation]
  );

  return (
    <div css={styles.trayWrapper}>
      <LocationServiceDetails
        location={currentLocation}
        childLocations={currentLocationChildren}
        isPinned={isPinnedLocation}
        onClose={onClose}
        onPinLocation={onPinLocation}
        onChangeLocation={onChangeLocation}
      />
    </div>
  );
};
